import { getPrimaryItem } from '~/utils/bundles';
import { items } from '@wg/wows-entities/const';
import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';

interface IBundleTitle {
    bundle: IBundle;
    className?: string;
}

const BundleTitle = ({ bundle, className }: IBundleTitle) => {
    const primaryItem = getPrimaryItem(bundle.entitlements);
    if (!primaryItem) {
        return <div className={className} dangerouslySetInnerHTML={{ __html: bundle.title }} />;
    }

    switch (primaryItem.type) {
        case items.VEHICLES:
            return (
                <div className={className}>
                    <WoWSEntity type={items.VEHICLES} id={primaryItem.identifier} />
                </div>
            );

        default:
            return <div className={className} dangerouslySetInnerHTML={{ __html: bundle.title }} />;
    }
};

export default BundleTitle;
